import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
export const GET_HIGHLIGHT_SUBJECT = registerQuery({
  fieldName: 'highlightSubject',
  args: ['objectTypeId', 'objectId'],
  fetcher: async ({
    objectTypeId,
    objectId
  }) => {
    return await http.get(`inbounddb-objects/v1/crm-objects/${objectTypeId}/${objectId}`, {
      query: {
        allPropertiesFetchMode: 'latest_version'
      }
    });
  }
});